import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["error"],
      _excluded2 = ["error"],
      _excluded3 = ["error"];
import { memoizeDeep, safeMerge } from "../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    textinput,
    rightElement,
    leftElement,
    rightElementCSS,
    leftElementCSS,
    footerStyle
  } = _ref;
  let floatingLabel = false,
      cssRoot = {},
      cssLabel = {},
      cssLabelError = {},
      cssInput = {},
      cssInputError = {},
      cssFooter = {},
      cssFooterError = {},
      cssRightElement = {},
      cssLeftElement = {};

  if (textinput) {
    const _textinput$label = textinput.label,
          {
      error: errorLabelStyles
    } = _textinput$label,
          commonLabelStyles = _objectWithoutProperties(_textinput$label, _excluded);

    cssLabel = commonLabelStyles;
    cssLabelError = errorLabelStyles;

    const _textinput$input = textinput.input,
          {
      error: errorInputStyles
    } = _textinput$input,
          commonInputStyles = _objectWithoutProperties(_textinput$input, _excluded2);

    cssInput = commonInputStyles;
    cssInputError = errorInputStyles;

    const _textinput$footer = textinput.footer,
          {
      error: errorFooterStyles
    } = _textinput$footer,
          commonFooterStyles = _objectWithoutProperties(_textinput$footer, _excluded3);

    cssFooter = safeMerge(commonFooterStyles, footerStyle);
    cssFooterError = errorFooterStyles;

    if (rightElement && rightElementCSS) {
      cssRightElement = safeMerge(textinput.rightElement, rightElementCSS);
    } else {
      cssRightElement = textinput.rightElement;
    }

    if (leftElement && leftElementCSS) {
      cssLeftElement = safeMerge(textinput.leftElement, leftElementCSS);
    } else {
      cssLeftElement = textinput.leftElement;
    }

    cssRoot = textinput === null || textinput === void 0 ? void 0 : textinput.root;
    floatingLabel = textinput === null || textinput === void 0 ? void 0 : textinput.floatingLabel;
  }

  return {
    floatingLabel,
    cssRoot,
    cssLabel,
    cssLabelError,
    cssInput,
    cssInputError,
    cssFooter,
    cssFooterError,
    cssRightElement,
    cssLeftElement
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme,
    rightElement,
    leftElement,
    rightElementCSS,
    leftElementCSS,
    footerStyle
  } = _ref2;
  const textinput = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.textinput;
  return setTheme({
    textinput,
    rightElement,
    leftElement,
    rightElementCSS,
    leftElementCSS,
    footerStyle
  });
}